/**
 * preinit
 * available functions for use in tpl/js
 *
 * $preDOM(callback)        - launch callback before domready, at the end of <body>
 * $preInit(callback)       - launch callback after domready, before init of classes
 * $postInit(callback)      - launch callback after init, before launch() of all classes
 * $postLaunch(callback)    - launch callback after launch() of all classes
 *
 * $register(obj, options)  - register class (obj) for init with some options:
 *                                condition - true to init always or function returning bool
 *                                prio      - int for sorting initialization (new X) order
 *                                events    - object with callbacks to window events
 *
 *>> preinit.js
 */

/**
 * TEMPORARY one-time nocache redirect (SHOPPANEL-3034) — remove in a week or two.
 * On the first admin load per browser, reload the current page once with
 * ?nocache=1 appended. Guarded by localStorage so it fires only once, ever.
 * Runs synchronously in <head> (preinit.bundle.js) before the main bundle so the
 * redirect happens before the rest of the page renders.
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'shoppanel_3034_nocache_redirect_done';

    try {
        if (window.localStorage.getItem(STORAGE_KEY)) {
            return;
        }

        window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
        // localStorage unavailable (private mode / disabled) — never redirect.
        return;
    }

    if (/[?&]nocache=/.test(window.location.search)) {
        return;
    }

    var separator = window.location.search ? '&' : '?';

    window.location.replace(
        window.location.pathname + window.location.search + separator + 'nocache=1' + window.location.hash
    );
})();

(function () {
    'use strict';

    if (!Function.prototype.bind) {
        Function.prototype.bind = function (oThis) {
            if (typeof this !== 'function') {
                // closest thing possible to the ECMAScript 5 internal IsCallable function
                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
            }

            var aArgs = Array.prototype.slice.call(arguments, 1),
                fToBind = this,
                fNOP = function () {},
                fBound = function () {
                    return fToBind.apply(this instanceof fNOP && oThis
                        ? this
                        : oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments)));
                };

            fNOP.prototype = this.prototype;
            fBound.prototype = new fNOP();

            return fBound;
        };
    }

    this.$ready = (function (_callback, _event) {
        var _f = (function (e) {
            this(e);
            e.detail[_event + 'Called'](this, e);
        }).bind(_callback);

        if (this.addEventListener) {
            this.addEventListener(_event, _f, false);
        } else if (this.attachEvent) {
            this.attachEvent(_event, _f);
        };

        if (this.$ready.registered[_event]) {
            this.$ready.registered[_event]++;
        } else {
            this.$ready.registered[_event] = 1;
        }
    }).bind(this);

    this.$ready.startTime = new Date;
    this.$ready.registered = {};
    this.$ready.called = {};

    for (let n in {'preInit' : 1, 'postInit' : 1, 'postLaunch' : 1}) {
        this['$' + n] = (function (_callback) {
            $ready(_callback, n);
        }).bind(this);
    }

    this.$register = (function (_obj, _options) {
        this.$ready(function (e) {
            e.detail.register(_obj, _options);
        }, 'preInit');
    }).bind(this);

    this.$registerClass = (function (_obj, _options) {
        this.$ready(function (e) {
            e.detail.registerClass(_obj, _options);
        }, 'preInit');
    }).bind(this);

    this.$registerTool = (function (_obj, _options) {
        this.$ready(function (e) {
            e.detail.registerTool(_obj, _options);
        }, 'preInit');
    }).bind(this);

    this.$registerFlags = (function (_obj, _options) {
        this.$ready(function (e) {
            e.detail.registerFlags(_obj, _options);
        }, 'preInit');
    }).bind(this);

    this.$registerLang = (function (_obj, _options) {
        this.$ready(function (e) {
            e.detail.registerLang(_obj, _options);
        }, 'preInit');
    }).bind(this);

    this.$registerScript = (function (src, async, isModule) {
        this.$ready.scriptList.push([src, async, isModule]);
    }).bind(this);

    this.$ready.scriptList = [];

    this.$ready.writeScriptList = (function () {
        for (let x = this.$ready.writeScriptList.index, slLength = this.$ready.scriptList.length; x < slLength; ++x) {

            const el = this.document.createElement('script');
            el.src = this.$ready.scriptList[x][0];

            if (true === this.$ready.scriptList[x][2]) {
                el.type = 'module';
            }

            if (true === this.$ready.scriptList[x][1]) {
                el.async = true;
                el.addEventListener('load', this.$ready.scriptLoaded, false);
                this.document.body.appendChild(el);
            } else {
                this.$ready.writeScriptList.index = (x + 1);
                el.addEventListener('load', this.$ready.writeScriptList.bind(this), false);
                el.addEventListener('load', this.$ready.scriptLoaded, false);
                this.document.body.appendChild(el);
                return;
            }
        }
    }).bind(this);

    this.$ready.scriptLoaded = (function () {
        this.$ready.writeScriptList.loaded++;
        if (this.$ready.writeScriptList.loaded >= this.$ready.scriptList.length) {
            this.$ready.writeScriptList.loadedAll = true;
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent('postLoad', false, false, null );
            this.dispatchEvent(evt);
        }
    }).bind(this);

    this.$ready.writeScriptList.index = 0;
    this.$ready.writeScriptList.loaded = 0;
    this.$ready.writeScriptList.loadedAll = false;

    const browserCheck = (function () {
        if (
            (
                (navigator.userAgent.indexOf('Firefox') != -1 && parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf('Firefox') + 8)) < 20) ||
                (navigator.userAgent.indexOf('MSIE') != -1 && parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf('MSIE') + 5).split(' ')[0]) < 9) ||
                (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Version') != -1 && parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf('Version') + 8).split(' ')[0]) < 4) ||
                (navigator.userAgent.indexOf('Opera') != -1 && parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf('Opera') + 6).split(' ')[0]) < 9)
            )
            && navigator.userAgent.indexOf('Android') == -1
        ) {
            document.getElementsByTagName('html')[0].className += ' not-supported-browser';

            if (document.getElementsByTagName('html')[0].className.indexOf('ctrl-auth') != -1) {
                var pC = document.getElementById('panel-change');
                pC.parentNode.removeChild(pC);
            }

            return false;
        } else {
            return true;
        }
    });

    if (typeof(window.document.addEventListener) === 'function') {
        window.document.addEventListener('DOMContentLoaded', (function () {
            if (browserCheck()) {
                setTimeout(this.$ready.writeScriptList, 1);
            }
        } ).bind(this));
    } else {
        const readyStateCheckInterval = setInterval(function () {
            if (document.readyState === 'complete') {
                document.createElement('aside');
                document.createElement('main');
                document.createElement('footer');

                browserCheck();
                clearInterval(readyStateCheckInterval);
            }
        }, 10);
    }
}).call(window);
